import { getAmountsFromCost, percentageToDecimal } from '../../services/Utils';

export const CUSTOMER_TYPE_PRICE_INIT_STATE = {
    franquicia: {
        name: 'Franquicia',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
    mayoreo: {
        name: 'Mayoreo',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
    mediomayoreo: {
        name: 'Medio mayoreo',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
    general: {
        name: 'Publico general',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
    franquicia2: {
        name: 'Franquicia 2',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
    franquicia3: {
        name: 'Franquicia 3',
        price: 0,
        taxAmount1: 0,
        taxAmount2: 0,
        importe: 0,
        percentage: 0,
        decimal: 0,
    },
};

export default function reducer(state, action) {
    switch (action.type) {
        case 'save_percentage': {
            const { type, percentage } = action.payload;
            const priceType = { ...state[type] };

            priceType.percentage = percentage;
            priceType.decimal = percentageToDecimal(percentage);

            return { ...state, [type]: priceType };
        }

        case 'calculate_all': {
            const { cost, taxDecimal1, taxDecimal2, taxDecimalTotal } = action.payload;

            const {
                franquicia, mayoreo, mediomayoreo, general, franquicia2, franquicia3
            } = state;

            return {
                ...state,
                franquicia: {
                    ...franquicia,
                    ...getAmountsFromCost(cost, franquicia.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                mayoreo: {
                    ...mayoreo,
                    ...getAmountsFromCost(cost, mayoreo.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                mediomayoreo: {
                    ...mediomayoreo,
                    ...getAmountsFromCost(cost, mediomayoreo.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                general: {
                    ...general,
                    ...getAmountsFromCost(cost, general.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                franquicia2: {
                    ...franquicia2,
                    ...getAmountsFromCost(cost, franquicia2.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                franquicia3: {
                    ...franquicia3,
                    ...getAmountsFromCost(cost, franquicia3.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal),
                },
                // [type]: calcTaxAux(...data),
            }
        }

        /**
         * Precio General se calcula diferente porque debemos respetar el precio final fijo puesto por el cliente en el formulario
         */
        case 'calculate_general': {
            const { cost, taxDecimal1, taxDecimal2, taxDecimalTotal, basePrice, baseImporte } = action.payload;

            const { general } = state;

            return {
                ...state,
                general: {
                    ...general,
                    ...getAmountsFromCost(cost, general.percentage, taxDecimal1, taxDecimal2, taxDecimalTotal, basePrice, baseImporte),
                },
            }
        }

        default: {
            return state;
        }
    }
}
